module.exports = __webpack_public_path__ + "img/sort03.bfc49b2f.jpg";